// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-content-add-banner {
    flex-grow: 1;
    max-width: 1200px;
    margin: 0 auto;
}

.add-banner-form {
    border-top: 2px solid #333;
}

.form-row {
    display: flex;
    align-items: stretch;
    border-bottom: 1px solid #ddd;
}

.form-row label:first-child {
    background-color: #f8f9fa;
    font-weight: bold;
    padding: 20px;
    width: 200px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
}

.form-row .form-field {
    padding: 15px 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-grow: 1;
    flex-wrap: wrap;
}

.form-row .form-field select,
.form-row .form-field input[type="text"] {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.form-row .form-field select {
    width: 300px;
}

.form-row .form-field input[type="text"] {
    flex-grow: 1;
    min-width: 200px;
}

.btn-file-select {
    padding: 10px 20px;
    background-color: black;
    border: 1px solid #ccc;
    cursor: pointer;
    border-radius: 5px;
}

.file-name {
    color: #888;
}

.size-input-group input {
    width: 100px;
}

.color-input-group input {
    width: 300px;
}

.color-input-group span {
    color: #888;
    font-size: 14px;
}

textarea.banner-text-input {
    width: 100%;
    height: 100px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    resize: vertical;
}

.form-actions-add-banner {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 40px;
}

.form-actions-add-banner button {
    padding: 15px 60px;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
}

.btn-back-banner {
    background-color: #222;
    color: white;
    border: none;
}

.btn-save-banner {
    background-color: #e84118;
    color: white;
    border: none;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .form-row label:first-child {
        width: 150px;
    }
    
    .form-row .form-field select {
        width: 250px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .form-row {
        flex-direction: column;
        align-items: flex-start;
    }

    .form-row label:first-child {
        width: 100%;
        background-color: transparent;
        padding: 15px 0 5px 0;
        border-bottom: none;
    }
    
    .form-row .form-field {
        width: 100%;
        padding: 5px 0 15px 0;
    }

    .form-row .form-field select,
    .form-row .form-field input[type="text"],
    .size-input-group input,
    .color-input-group input {
        width: 100%;
    }

    .form-actions-add-banner {
        flex-direction: column;
    }
}

/* S3 업로드 관련 스타일 */
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.upload-progress-bar {
    width: 100px;
    height: 4px;
    background-color: #f0f0f0;
    border-radius: 2px;
    overflow: hidden;
}

.upload-progress-fill {
    height: 100%;
    background-color: #007bff;
    transition: width 0.3s ease;
}

.image-preview-container {
    position: relative;
    display: inline-block;
}

.image-preview {
    max-width: 300px;
    max-height: 200px;
    border: 1px solid #ddd;
    border-radius: 4px;
    transition: opacity 0.2s, transform 0.2s;
    display: block;
}

.image-preview:hover {
    opacity: 0.8;
    transform: scale(1.02);
}

.upload-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
}

.spinner {
    border: 3px solid #f3f3f3;
    border-top: 3px solid #007bff;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
    margin: 0 auto 8px;
}

.upload-status {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.upload-status-text {
    color: #007bff;
    font-size: 14px;
}

.upload-complete {
    color: green;
    font-weight: bold;
}

.remove-btn {
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 2px 8px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.remove-btn:hover {
    background: #c82333;
}

.s3-link {
    color: #007bff;
    text-decoration: none;
    font-size: 12px;
    transition: color 0.2s;
}

.s3-link:hover {
    color: #0056b3;
    text-decoration: underline;
} `, "",{"version":3,"sources":["webpack://./src/admin/css/AddBannerPage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA,+BAA+B;AAC/B;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,6BAA6B;QAC7B,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,qBAAqB;IACzB;;IAEA;;;;QAII,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA,kBAAkB;AAClB;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B","sourcesContent":[".admin-content-add-banner {\n    flex-grow: 1;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.add-banner-form {\n    border-top: 2px solid #333;\n}\n\n.form-row {\n    display: flex;\n    align-items: stretch;\n    border-bottom: 1px solid #ddd;\n}\n\n.form-row label:first-child {\n    background-color: #f8f9fa;\n    font-weight: bold;\n    padding: 20px;\n    width: 200px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n}\n\n.form-row .form-field {\n    padding: 15px 20px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-grow: 1;\n    flex-wrap: wrap;\n}\n\n.form-row .form-field select,\n.form-row .form-field input[type=\"text\"] {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.form-row .form-field select {\n    width: 300px;\n}\n\n.form-row .form-field input[type=\"text\"] {\n    flex-grow: 1;\n    min-width: 200px;\n}\n\n.btn-file-select {\n    padding: 10px 20px;\n    background-color: black;\n    border: 1px solid #ccc;\n    cursor: pointer;\n    border-radius: 5px;\n}\n\n.file-name {\n    color: #888;\n}\n\n.size-input-group input {\n    width: 100px;\n}\n\n.color-input-group input {\n    width: 300px;\n}\n\n.color-input-group span {\n    color: #888;\n    font-size: 14px;\n}\n\ntextarea.banner-text-input {\n    width: 100%;\n    height: 100px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    resize: vertical;\n}\n\n.form-actions-add-banner {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 40px;\n}\n\n.form-actions-add-banner button {\n    padding: 15px 60px;\n    font-size: 16px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-weight: bold;\n}\n\n.btn-back-banner {\n    background-color: #222;\n    color: white;\n    border: none;\n}\n\n.btn-save-banner {\n    background-color: #e84118;\n    color: white;\n    border: none;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .form-row label:first-child {\n        width: 150px;\n    }\n    \n    .form-row .form-field select {\n        width: 250px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .form-row {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .form-row label:first-child {\n        width: 100%;\n        background-color: transparent;\n        padding: 15px 0 5px 0;\n        border-bottom: none;\n    }\n    \n    .form-row .form-field {\n        width: 100%;\n        padding: 5px 0 15px 0;\n    }\n\n    .form-row .form-field select,\n    .form-row .form-field input[type=\"text\"],\n    .size-input-group input,\n    .color-input-group input {\n        width: 100%;\n    }\n\n    .form-actions-add-banner {\n        flex-direction: column;\n    }\n}\n\n/* S3 업로드 관련 스타일 */\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.upload-progress-bar {\n    width: 100px;\n    height: 4px;\n    background-color: #f0f0f0;\n    border-radius: 2px;\n    overflow: hidden;\n}\n\n.upload-progress-fill {\n    height: 100%;\n    background-color: #007bff;\n    transition: width 0.3s ease;\n}\n\n.image-preview-container {\n    position: relative;\n    display: inline-block;\n}\n\n.image-preview {\n    max-width: 300px;\n    max-height: 200px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    transition: opacity 0.2s, transform 0.2s;\n    display: block;\n}\n\n.image-preview:hover {\n    opacity: 0.8;\n    transform: scale(1.02);\n}\n\n.upload-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(255, 255, 255, 0.8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n}\n\n.spinner {\n    border: 3px solid #f3f3f3;\n    border-top: 3px solid #007bff;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    animation: spin 1s linear infinite;\n    margin: 0 auto 8px;\n}\n\n.upload-status {\n    margin-top: 8px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.upload-status-text {\n    color: #007bff;\n    font-size: 14px;\n}\n\n.upload-complete {\n    color: green;\n    font-weight: bold;\n}\n\n.remove-btn {\n    background: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 2px 8px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.remove-btn:hover {\n    background: #c82333;\n}\n\n.s3-link {\n    color: #007bff;\n    text-decoration: none;\n    font-size: 12px;\n    transition: color 0.2s;\n}\n\n.s3-link:hover {\n    color: #0056b3;\n    text-decoration: underline;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
